import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { get, toUpper } from "lodash";
import Grid from "@material-ui/core/Grid";

import { fetchPost } from "../../../api/fetch";
import ProfileLink from "../../Common/ProfileLink";
import AddTemperature from "../../Profiles/AddTemperature";
import TemperatureDetails from "../Temperature/TemperatureDetails";
import InfoSection from "../../Common/InfoSection";
import { LANGUAGES, human } from "../../../constants/common";
import {
  displayedTemperature,
  getDisplayedTemperatureAttr,
  getFinalTemperature,
  getMeasureType,
  isOverThreshold,
  getThreshold,
} from "../../../utils/temperature";
import { getLov } from "../../../utils/lov";
import images from "../../../assets/img/images";

const LogDetailsTemperature = (props) => {
  const { powerUserMode, details, log, language, refreshDetection } = props;
  const [lov, setLov] = React.useState({});

  React.useEffect(() => {
    const fetchLov = async () => {
      setLov({
        88: await getLov(88),
      });
    };
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [finalTemp, finalTempEvent] = getFinalTemperature(
    get(log, ["measuredTemperature"])
  );
  const measureType = getMeasureType(finalTempEvent);
  const attr = getDisplayedTemperatureAttr(measureType);
  const fever = isOverThreshold(
    finalTemp,
    getThreshold(get(log, ["measuredTemperature"]))
  );

  const onSubmitTemperature = async (tempEventGroup, tempEvent) => {
    try {
      let tempEventGroupId = get(log, ["measuredTemperature", "id"]);
      if (!tempEventGroupId) {
        tempEventGroup.parent_id = get(log, ["id"]);
        let eventGroup = await fetchPost("event_groups", tempEventGroup);
        tempEventGroupId = get(eventGroup, ["id"]);
      }
      tempEvent.event_group_id = tempEventGroupId;
      await fetchPost("events", tempEvent);
      refreshDetection();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Grid container direction="column">
      <ProfileLink
        profile={get(details, ["log", "profile"])}
        overriden={get(details, ["override"])}
        type={human}
        score={get(details, ["lukeIndex"])}
      />
      <Grid item style={{ margin: "24px 16px 0px" }}>
        <Grid container>
          <InfoSection
            title2={I18n.get("site_siteAndZone")}
            values={[
              `${get(log, ["main", "site"])}/${get(log, ["main", "zone"])}`,
            ]}
            style={{ marginRight: "50px" }}
          />
          <InfoSection
            title2={I18n.get("profiles_dateTime")}
            values={[get(log, ["main", "dateTime"])]}
            style={{ marginRight: "50px" }}
          />
          {powerUserMode && (
            <InfoSection
              title2={I18n.get("events_eventGroupId")}
              values={[get(log, ["id"])]}
            />
          )}
        </Grid>
      </Grid>
      <Grid item style={{ margin: "20px 24px 0px" }}>
        <div className="bold-500">
          {toUpper(I18n.get("site_finalTemperature"))}
        </div>
        {finalTemp ? (
          <Grid container alignItems="center">
            <Grid item className="flexCenter" style={{ marginRight: "7px" }}>
              <img
                src={
                  fever
                    ? images.temperatureButtonRed
                    : images.temperatureButtonGreen
                }
                alt="temperature_status"
              />
            </Grid>
            <Grid item style={{ fontSize: "1.857em" }}>
              {displayedTemperature(finalTempEvent, attr, lov)}
            </Grid>
          </Grid>
        ) : null}
        <div style={{ margin: "12px 6px" }}>
          <AddTemperature
            profile={get(log, ["human", "profile"])}
            language={language}
            onSubmit={onSubmitTemperature}
          />
        </div>
      </Grid>
      <Grid item style={{ margin: "10px 0px" }}>
        <TemperatureDetails
          profileId={get(details, ["log", "profile", "id"])}
          currentTemperature={get(log, ["measuredTemperature"])}
          language={language}
          maxWidth={"calc(100vw - 214px)"}
          logDetailsDisplay
          refresh={refreshDetection}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    powerUserMode: get(state, ["common", "powerUserModeEnabled"]),
  };
};

LogDetailsTemperature.propTypes = {
  language: PropTypes.oneOf(LANGUAGES),
};

export default connect(mapStateToProps)(LogDetailsTemperature);
